<template>
  <v-dialog scrollable max-width="300px" v-model="showDialog">
    <template v-slot:activator="{ on }">
      <div class="my-2">
        <v-icon small :disabled="disabled" v-on="on" @click="init">edit</v-icon>
      </div>
    </template>
    <v-card>
      <v-card-title>
        <h4>RECO</h4>
      </v-card-title>
      <v-card-text>
        
        <v-form ref="form" v-model="validForm">
          <v-text-field
            label="edadMinima"
            v-model="parametros.edadMinima"
            :rules="[rules.edad]"
          />

          <v-text-field
            label="antiguedadMinima"
            v-model="parametros.antiguedadMinima"
            :rules="[rules.edad]"
          />

          <v-text-field
            label="Socio Activo?"
            v-model="parametros.socioActivo"
            :rules="[rules.required, rules.sino]"
          />

          <v-text-field
            label="Socio Administravo?"
            v-model="parametros.socioAdministrado"
            :rules="[rules.required, rules.sino]"
          />
          <v-text-field
            label="Monto"
            v-model="parametros.monto"
            :rules="[rules.required, rules.monto]"
          />
          <MyDatePicker
            :fecha="parametros.fechaCorte"
            label="Fecha corte"
            @fecha="setFechaCorte"
            :rules="[rules.requiredFechaCorte]"
            format="DMY"
          />
          <!-- <v-text-field
            label="Fecha Corte"
            v-model="parametros.fechaCorte"
            :rules="[rules.required]"
          /> -->
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="info" @click="volver">Volver</v-btn>
        <v-btn color="info" @click="confirmar" :disabled="!validForm"
          >Actualizar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import MyDatePicker from "@/components/shared/MyDatePicker.vue";

export default Vue.extend({
  props: ["disabled", "regla"],
  data() {
    return {
      loading: false,
      showDialog: false,
      validForm: false,
      nuevoMonto: 0,
      rules: {
        requiredFechaCorte: (value) => {
          if (this.parametros.edadMinima || this.parametros.antiguedadMinima) {
            if (!value)
              return "Ingrese Fecha corte si existe valor en edad y/o antiguedad";
          }
          return true;
        },
        required: (value) => !!value || "Requerido.",
        numero: (value) => {
          if (isNaN(value)) return false;
          if (+value) {
            return (
              (+value > 0 && +value <= 1000) || "Ingrese valor entre 1 y 1000"
            );
          }
          return true;
        },
        edad: (value) => {
          if (value) {
            return (value > 0 && value <= 100) || "Ingrese valor entre 1 y 100";
          }
          return true;
        },
        sino: (value) => {
          if (value) {
            return value == "SI" || value == "NO" || "Ingrese SI o NO";
          }
          return true;
        },
        monto: (value) => {
          if (isNaN(value)) {
            return false;
          }
          if (value) {
            return value > 0 || "Ingrese monto valido";
          }
          return true;
        },
        counter: (value) => value.length <= 1000 || "Maximo 100 caracteres",
      },
      parametros: {
        edadMinima: null,
        antiguedadMinima: null,
        socioActivo: null,
        socioAdministrado: null,
        monto: null,
        fechaCorte: null,
      },
    };
  },
  mounted() {},
  methods: {
    init() {
      this.parametros = {
        porcentaje: null,
        segundosTocada: null,
      };

      this.regla.valores.forEach((v) => {
        if (v.nombre === "edadMinima") {
          this.parametros.edadMinima = v.valor;
        } else if (v.nombre === "antiguedadMinima") {
          this.parametros.antiguedadMinima = v.valor;
        } else if (v.nombre === "socioActivo") {
          this.parametros.socioActivo = v.valor;
        } else if (v.nombre === "socioAdministrado") {
          this.parametros.socioAdministrado = v.valor;
        } else if (v.nombre === "monto") {
          this.parametros.monto = v.valor;
        } else if (v.nombre === "fechaCorte") {
          this.parametros.fechaCorte = v.valor;
        }
      });
    },
    close() {
      this.showDialog = false;
    },
    volver() {
      this.showDialog = false;
    },
    confirmar() {
      // setTimeout(() => {
      //   this.$emit("nuevoMontoBolsa", {
      //     bolsaId: this.id,
      //     nuevoMontoBolsa: +this.nuevoMonto,
      //   });

      //this.close();
      // }, 500);

      const valores = [];
      for (let key in this.parametros) {
        if (this.parametros[key]) {
          valores.push({ nombre: key, valor: this.parametros[key] });
        }
      }

      axios
        .post(`/regla/${this.regla.id}/actualizarParametros/`, valores)
        .then((response) => {
          console.log(response);
          this.$emit("actualizado", response.data);
          this.close();
        })
        .catch((err) => {
          this.loading = false;
          this.nuevaCedula = this.cedula;
          console.log(err);
          this.errorMessage = "Error en la consulta";
        });
    },
    setFechaCorte(fecha) {
      this.parametros.fechaCorte = fecha;
    },
  },
  components: {
    MyDatePicker,
  },
});
</script>